import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentWillMount() {
        this.label = 'My Account - Karma Coins©';
    }

    render({ user }) {
        const avatar = this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';

        if (user.logged_in) {
            const total_kcs = user.kcs.total.toLocaleString();

            return (
                <user-menu-mobile>
                    <section
                      class={`category-header ${this.props.currentOpen == this.label ? 'nav-accordion-expanded' : ''}`}
                      onClick={this.toggle}
                    >
                        <div class='avatar-mask'>
                            <img src={avatar} alt='User profile picture' class='avatar' />
                        </div>
                        <div class='account-details my-account'>
                            <h5>My Account</h5>
                            <p>{total_kcs} Karma Coins<sup>©</sup></p>
                        </div>
                    </section>
                    <section
                      class={`user-details ${this.props.currentOpen == this.label ? 'nav-accordion-expanded' : ''}`}
                    >
                        <ul>
                            <li class='ub-journal no-detail-link'>
                                <a
                                  href='https://product.tarot.com/about-you/journal'
                                  class='subcategory'
                                  onClick={() => this.trackClick('My Journal')}
                                >
                                    <h5>My Journal</h5>
                                </a>
                            </li>
                            <li class='ub-karma-coins my-kcs'>
                                <a
                                  href='/store/karma-coins'
                                  class='subcategory'
                                  onClick={() => this.trackClick('My Account - Karma Coins© Balance')}
                                >
                                    <span />
                                    <div class='account-details'>
                                        <h5>Karma Coins<sup>©</sup></h5>
                                        <p>{total_kcs} Balance</p>
                                    </div>
                                </a>
                            </li>
                            <li class='ub-gear no-detail-link'>
                                <a
                                  href='https://tarot.com/member/settings'
                                  class='subcategory'
                                  onClick={() => this.trackClick('My Account - Settings')}
                                >
                                    <h5>Account Settings</h5>
                                </a>
                            </li>
                            <li class='ub-logout no-detail-link'>
                                <a
                                  href='/login/logout'
                                  class='subcategory'
                                  onClick={() => this.trackClick('Log Out')}
                                >
                                    <h5>Log Out</h5>
                                </a>
                            </li>
                        </ul>
                    </section>
                </user-menu-mobile>
            );
        }

        return null;
    }

    toggle = () => {
        const action = this.props.currentOpen == this.label ? 'Close' : 'Open';
        const currentOpen = this.props.currentOpen == this.label ? null : this.label;

        this.props.updateOpen(currentOpen);
        this.props.trackPromo(['Navigation', this.label]);
        this.props.trackEvent(['Navigation', action, this.label]);
    }

    trackClick = (label) => {
        this.props.trackPromo(['Navigation', label]);
        this.props.trackPromo(['Navigation', 'LI Click', label]);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    currentOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].currentOpen,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    updateOpen: payload => dispatch({ type: 'nav-bar-mobile:update', payload: {currentOpen: payload} }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/user/menu-mobile.js